import classNames from "classnames/bind";
import styles from "./Loading.module.scss";
const css = classNames.bind(styles);

function Loading() {
  return (
    <div className={css("wrapper")}>
      <div className={css("container")}>
        <div className={css("loading")}></div>
        <p className={css("text-loading")}>Loading...</p>
      </div>
    </div>
  );
}

export default Loading;
